import React, { useState } from 'react'
import styles from './PodiumAmenitiesCarousel.module.css'

// Replace with actual imports:
import p1 from '../../assets/podium-level-img1.jpg'
import p2 from '../../assets/podium-level-img2.jpg'
import p3 from '../../assets/podium-level-img3.jpg'


import g1 from '../../assets/ground-level-img1.jpg'
import g2 from '../../assets/ground-level-img2.jpg'


const levels = [
    {
        level: 'Podium Level',
        subtitle: 'Spaces for relaxation and recovery',
        amenities: [
            'Swimming Pool (Adults + Kids)',
            'Zen Garden',
            'Spa and Sauna',
            'Guest Suites',
            'Ganesh Temple',
        ],
        images: [p1, p2, p3],
    },
    {
        level: 'Ground Level',
        subtitle: 'Social spaces crafted for connection',
        amenities: [
            'Grand Ballroom',
            'Private Dining Room',
            'Business Lounge',
            'Library & Reading Room',
            'Screening Room',
        ],
        images: [g1, g2],
    },
]

const PodiumAmenitiesCarousel = () => {
    const [activeLevelIdx, setActiveLevelIdx] = useState(0)
    const [activeImg, setActiveImg] = useState(0)
    const [animating, setAnimating] = useState(false)

    const level = levels[activeLevelIdx]

    const switchLevel = (idx) => {
        if (idx === activeLevelIdx || animating) return
        setAnimating(true)
        setTimeout(() => {
            setActiveLevelIdx(idx)
            setActiveImg(0)
            setAnimating(false)
        }, 350)
    }

    const prevImg = () => {
        if (animating) return
        setActiveImg((p) => (p - 1 + level.images.length) % level.images.length)
    }

    const nextImg = () => {
        if (animating) return
        setActiveImg((p) => (p + 1) % level.images.length)
    }

    return (
        <section className={styles.section}>

            {/* ── Header ── */}
            <div className={styles.header}>
                <span className={styles.eyebrow}>
                    <span className={styles.eyebrowLine}></span>
                    AMENITIES
                    <span className={styles.eyebrowLine}></span>
                </span>
                <h2 className={styles.sectionTitle}>
                    Crafted for <em>Every Moment</em> of Your Life
                </h2>
            </div>

            {/* ── Level Pills ── */}
            <div className={styles.pills}>
                {levels.map((l, i) => (
                    <button
                        key={i}
                        className={`${styles.pill} ${i === activeLevelIdx ? styles.pillActive : ''}`}
                        onClick={() => switchLevel(i)}
                    >
                        {l.level}
                    </button>
                ))}
            </div>

            {/* ── Body ── */}
            <div className={`${styles.body} ${animating ? styles.bodyFade : ''}`}>

                {/* LEFT: Image grid */}
                <div className={styles.imageGrid}>

                    {/* Main large image */}
                    <div className={styles.mainImgBox}>
                        <img
                            key={`${activeLevelIdx}-${activeImg}`}
                            src={level.images[activeImg]}
                            alt={level.level}
                            className={styles.mainImg}
                        />
                        <div className={styles.mainOverlay}></div>
                        <span className={styles.caption}>Artist's Impression</span>

                        <button className={`${styles.arrow} ${styles.arrowL}`} onClick={prevImg} aria-label="Previous">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5M12 5l-7 7 7 7" />
                            </svg>
                        </button>
                        <button className={`${styles.arrow} ${styles.arrowR}`} onClick={nextImg} aria-label="Next">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>

                    {/* 3 thumbnails below */}
                    <div className={styles.thumbGrid}>
                        {level.images.map((img, i) => (
                            <button
                                key={i}
                                className={`${styles.thumbBox} ${activeImg === i ? styles.thumbActive : ''}`}
                                onClick={() => setActiveImg(i)}
                                aria-label={`View image ${i + 1}`}
                            >
                                <img src={img} alt="" className={styles.thumbImg} />
                                <div className={styles.thumbOverlay}></div>
                            </button>
                        ))}
                    </div>

                </div>

                {/* RIGHT: Info */}
                <div className={styles.info}>
                    <p className={styles.infoEyebrow}>
                        <span className={styles.infoEyebrowDot}></span>
                        {level.level}
                    </p>

                    <h3 className={styles.infoTitle}>{level.level}</h3>
                    <p className={styles.infoSubtitle}>{level.subtitle}</p>

                    <ul className={styles.list}>
                        {level.amenities.map((item, i) => (
                            <li key={i} className={styles.listItem}>
                                <span className={styles.bullet}></span>
                                {item}
                            </li>
                        ))}
                    </ul>

                    {/* Image indicator */}
                    <div className={styles.indicators}>
                        {level.images.map((_, i) => (
                            <button
                                key={i}
                                className={`${styles.indicator} ${i === activeImg ? styles.indicatorActive : ''}`}
                                onClick={() => setActiveImg(i)}
                                aria-label={`Image ${i + 1}`}
                            ></button>
                        ))}
                    </div>
                </div>

            </div>

        </section>
    )
}

export default PodiumAmenitiesCarousel